<template>
  <div>
    <base-confirm
      v-if="visible"
      @close="$emit('close')"
      @confirmed="onConfirmed"
      size="max-w-xl"
      message="Sudah ada faktur pengemasan. Anda yakin ingin membatalkan?"
      type="danger"
      icon-type="badge"
      title="Batalkan Faktur Pengemasan"
      confirm-text="Ya"
      cancel-text="Tutup"
      :disabled="!description"
      visible
    >
      <template #content>
        <base-input inset label="Alasan Pembatalan" placeholder="Alasan Pembatalan" tag="textarea" rows="5" v-model="description" />
      </template>
    </base-confirm>
    <loading v-if="loading" />
  </div>
</template>

<script>
import BaseConfirm from '@/components/base/BaseConfirm.vue';
import { requestMixin } from '@/mixins/request/request';
import { mapActions } from 'vuex';

export default {
  components: { BaseConfirm },
  mixins: [requestMixin],
  props: {
    visible: Boolean,
    stockMovementId: String
  },
  emits: ['close', 'confirmed'],
  data() {
    return {
      loading: false,
      description: ''
    };
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async onConfirmed() {
      this.loading = true;

      const [, err] = await this.request(
        `/api/v1/stock-movements/${this.stockMovementId}/-actions/cancel-pack`,
        {
          method: 'patch',
          data: {
            description: this.description
          }
        }
      );

      if (err) {
        this.createAlert({
          data: this.getRequestErrorMessage(err),
          status: 'error',
        });
      } else {
        this.$emit('confirmed');
      }

      this.loading = false;
    },
  },
};
</script>
